import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the types for the loader context
interface PopupContextType {
    showPopup: boolean;
    setshowPopup: React.Dispatch<React.SetStateAction<boolean>>;
    
}

// Create a context for the loader state
const PopupContext = createContext<PopupContextType | undefined>(undefined);

export function usePopup(): PopupContextType {
    const context = useContext(PopupContext);
    if (!context) {
        throw new Error('usePopup must be used within a PopupProvider');
    }
    return context;
}

interface PopupProviderProps {
    children: React.ReactNode;
}



export const PopupProvider : React.FC<PopupProviderProps> = ({ children }) => {
    const [showPopup, setshowPopup] = useState(false);

    // The value that will be provided to any descendant components
    const value: PopupContextType = { showPopup, setshowPopup };

    return (
        <PopupContext.Provider value={value}>
            {children}
        </PopupContext.Provider>
    );
};
